import React, { useCallback, useMemo } from "react";
import UserAvatar from "../../../../component/user-avatar";
import ChitChatMenu, {
  ChitChatMenuItem,
} from "../../../../component/chit-chat-menu";
import { MdSearch } from "react-icons/md";
import { StyledInput } from "../../../auth/section/auth.styled";
import { Box, styled, Theme } from "@mui/material";
import { useCurrentUser } from "../../../../api-hooks/use-current-user";
import { useLogoutUser } from "../../../../api-hooks/use-logout-user";
import { useUpdateProfilePicture } from "../../../../api-hooks/use-update-profile-picture";

const StyledInputContainer = styled(Box)(({ theme }: { theme: Theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  padding: "0.5rem",
  margin: "0.5rem 0.8rem",
  transition: "all 0.5s",
  borderBottom: `1px solid ${theme.palette.text.secondary}`,
  borderRadius: "0.5rem",
  backgroundColor: theme.palette.grey.A200,
  "& input": {
    backgroundColor: theme.palette.grey.A200,
  },
}));

const StyledTopBar = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0.8rem 1rem",
  backgroundColor: theme.palette.grey.A200,
}));

const StyledLabel = styled("label")(() => ({
  cursor: "pointer",
  "&:hover": {
    opacity: 0.8,
    transition: "all 0.5s",
  },
}));

const ChatListTopBar = () => {
  const { user } = useCurrentUser();
  const { logout } = useLogoutUser();
  const { mutate } = useUpdateProfilePicture();

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  const menuItems: ChitChatMenuItem[] = useMemo(() => {
    return [{ name: "Logout", onClick: handleLogout }];
  }, [handleLogout]);

  const handleProfilePictureUpdate = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event?.target?.files;
    if (file && user) {
      mutate({ file: file[0], userId: user.id });
    }
  };

  return (
    <>
      <StyledTopBar>
        <StyledLabel htmlFor={"profile-picture"}>
          <UserAvatar profileImage={user?.profilePicture} size={45} />
        </StyledLabel>
        <ChitChatMenu menuItems={menuItems} />
      </StyledTopBar>
      <StyledInputContainer>
        <MdSearch size={25} />
        <StyledInput placeholder="Search for chat" />
      </StyledInputContainer>
      <input
        id={"profile-picture"}
        style={{ display: "none" }}
        type="file"
        onChange={handleProfilePictureUpdate}
        accept="image/*"
      />
    </>
  );
};

export default ChatListTopBar;
